module.exports = __webpack_public_path__ + "img/pet.27e0c652.png";